import { create } from "zustand";

interface UIState {
  darkMode: boolean;
  sidebarCollapsed: boolean;
  mobileMenuOpen: boolean;
  toggleDarkMode: () => void;
  setDarkMode: (value: boolean) => void;
  toggleSidebar: () => void;
  setSidebarCollapsed: (value: boolean) => void;
  toggleMobileMenu: () => void;
  closeMobileMenu: () => void;
}

const savedTheme = typeof window !== "undefined" ? localStorage.getItem("theme") : null;

export const useUIStore = create<UIState>((set) => ({
  darkMode: savedTheme === "dark",
  sidebarCollapsed: false,
  mobileMenuOpen: false,

  toggleDarkMode: () =>
    set((state) => {
      const next = !state.darkMode;
      localStorage.setItem("theme", next ? "dark" : "light");
      document.documentElement.classList.toggle("dark", next);
      return { darkMode: next };
    }),

  setDarkMode: (value: boolean) => {
    localStorage.setItem("theme", value ? "dark" : "light");
    document.documentElement.classList.toggle("dark", value);
    set({ darkMode: value });
  },

  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setSidebarCollapsed: (value: boolean) => set({ sidebarCollapsed: value }),
  toggleMobileMenu: () => set((state) => ({ mobileMenuOpen: !state.mobileMenuOpen })),
  closeMobileMenu: () => set({ mobileMenuOpen: false }),
}));
